import styled from 'styled-components';

const Wrap = styled.div`
  text-align: center;
  font-style: italic;
  font-size: 14px;
  line-height: 1;
  padding: 8px 14px;
`;

export { Wrap };
